import { render, staticRenderFns } from "./GeneratePDF.vue?vue&type=template&id=353b26a2"
import script from "./GeneratePDF.vue?vue&type=script&lang=js"
export * from "./GeneratePDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports